<div class="tools-container py-5 px-3">
  <!-- Zip-Text Card -->
  <div class="tool-card">
    <div class="tool-icon">📝</div>
    <h2>{{ TITLE.ZIP_TEXT }}</h2>
    <p>{{ DESCRIPTION.ZIP_TEXT }}</p>
    <button routerLink="/text/">Go to Tool</button>
  </div>

  <!-- Zip-URL Card -->
  <div class="tool-card">
    <div class="tool-icon">🔗</div>
    <h2>{{ TITLE.ZIP_URL }}</h2>
    <p>{{ DESCRIPTION.ZIP_URL }}</p>
    <button routerLink="/url/">Go to Tool</button>
  </div>

  <!-- Zip-QR Card -->
  <div class="tool-card">
    <div class="tool-icon">📷</div>
    <h2>{{ TITLE.ZIP_QR }}</h2>
    <p>{{ DESCRIPTION.ZIP_QR }}</p>
    <button routerLink="/qr/">Go to Tool</button>
  </div>

  <!-- Zip-File Card -->
  <div class="tool-card">
    <div class="tool-icon">📁</div>
    <h2>{{ TITLE.ZIP_FILE }}</h2>
    <p>{{ DESCRIPTION.ZIP_FILE }}</p>
    <button routerLink="/file/">Go to Tool</button>
  </div>
</div>
